// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\MapSettings.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// MapSettingsData is the class that MapSettings serializes to/from
export interface MapSettingsData {
	
    ImageUrl : string | null;
	
    Latitude : number;
    Longitude : number;
    Zoom : number;
}

// MapSettingsOptions is the class which may be passed to the MapSettings constructor to define optional initial data values
export interface MapSettingsOptions {
	
    ImageUrl? : string | null;
	
    Latitude? : number;
    Longitude? : number;
    Zoom? : number;
}

export class MapSettings {
	
    public ImageUrl : DataSignal<string | null>;
	
    public Latitude : DataSignal<number>;
    public Longitude : DataSignal<number>;
    public Zoom : DataSignal<number>;

    constructor();
    constructor(data : MapSettingsOptions);
    constructor(data: MapSettingsOptions | null = null) {
	    
        this.ImageUrl = jsonableObservable(S.value<string | null>(data && data.ImageUrl !== undefined ? data.ImageUrl : null));
	    
        this.Latitude = jsonableObservable(S.value<number>(data && data.Latitude !== undefined ? data.Latitude : 0));
        this.Longitude = jsonableObservable(S.value<number>(data && data.Longitude !== undefined ? data.Longitude : 0));
        this.Zoom = jsonableObservable(S.value<number>(data && data.Zoom !== undefined ? data.Zoom : 0));
    }

    static key(obj : MapSettings) {
        return ;
    }
    
    static dataKey(obj : MapSettingsOptions) {
        return ;
    }

    static update(obj : MapSettings, data : MapSettingsOptions) {
        S.freeze(() => {
	        
            if (data.ImageUrl !== undefined) obj.ImageUrl(data.ImageUrl);
	        
            if (data.Latitude !== undefined) obj.Latitude(data.Latitude);
            if (data.Longitude !== undefined) obj.Longitude(data.Longitude);
            if (data.Zoom !== undefined) obj.Zoom(data.Zoom);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/MapSettings.ts